import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";
import StickyBottomNav from "../../../components/Navbar/StickyBottomNav";
import UpComingEvent from "../../../components/UpcomingEvent/UpcomingEvent";
import MyCalendar from "../../../components/MyCalendar/MyCalendar";

const CalendarEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/calendar-events`);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        setEvents(data);
      } catch (error) {
        console.error('Error fetching events:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [apiUrl]);

  return (
    <div className="min-h-screen bg-lightTeal">
      <Navbar />
      
      <div className="pt-12 pb-24 px-6 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="font-display text-h1 text-secondary mb-4">Volunteer Events</h1>
            <p className="text-bodyLarge text-textPrimary max-w-2xl mx-auto mb-4">
              Join us for upcoming events and make a difference in refugee communities
            </p>
            <div className="w-16 h-1 bg-cta mx-auto"></div>
          </div>

          {loading ? (
            <div className="flex flex-col items-center justify-center h-[60vh]">
              <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
              <p className="mt-6 text-bodyLarge text-textPrimary">Loading events...</p>
            </div>
          ) : (
            <div className="space-y-12">
              <div className="max-w-4xl mx-auto">
                <UpComingEvent events={events} />
              </div>

              <div className="w-full">
                <MyCalendar events={events} />
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
      <StickyBottomNav />
    </div>
  );
};

export default CalendarEvents;